"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
/**
 * toast
 */
function Toast(props) {
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "qt_toast" }, props.children), document.body);
}
exports.Toast = Toast;
